import { AdditionalServiceData, Service } from '@mews-commander/data-access';
import { useCurrencyFormat } from '../../../../../core/globalization/hooks/useCurrencyFormat';

export const useServiceCurrency = (service: Service) => {
    const { basePrice } = service.data.value as AdditionalServiceData;
    const defaultCurrencyCode = basePrice.currency;
    const currencyFormat = useCurrencyFormat(defaultCurrencyCode);

    return {
        currency: defaultCurrencyCode,
        ...currencyFormat,
    };
};
